/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug Generator — Text to URL Slug | Toolverse`)
};

const es_sg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de slug — Texto a slug de URL | Toolverse`)
};

const de_sg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug-Generator — Text zu URL-Slug | Toolverse`)
};

const nl_sg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL Slug Generator — Tekst naar URL Slug | Toolverse`)
};

const fr_sg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de slug — Texte vers slug URL | Toolverse`)
};

const it_sg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di slug — Da testo a slug URL | Toolverse`)
};

const pt_br2_sg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Slug — Texto para Slug de URL | Toolverse`)
};

const pt_sg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Slugs — Texto para Slug de URL | Toolverse`)
};

const ja_sg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スラグジェネレータ — テキストからURLスラグへ | Toolverse`)
};

const zh_sg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug 生成器 — 文本转 URL Slug | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sg_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sg_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sg_meta_title", locale)
	if (locale === "en") return en_sg_meta_title(inputs)
	if (locale === "es") return es_sg_meta_title(inputs)
	if (locale === "de") return de_sg_meta_title(inputs)
	if (locale === "nl") return nl_sg_meta_title(inputs)
	if (locale === "fr") return fr_sg_meta_title(inputs)
	if (locale === "it") return it_sg_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_sg_meta_title(inputs)
	if (locale === "pt") return pt_sg_meta_title(inputs)
	if (locale === "ja") return ja_sg_meta_title(inputs)
	return zh_sg_meta_title(inputs)
};